<template>
  <div>
    <div class="vx-row flex flex-col">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <h3>Update Data Dinas</h3>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-after="true"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Nama Dinas"
                class="w-full"
                v-model="agency.name"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-after="true"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Inisial Dinas"
                class="w-full"
                v-model="agency.initial"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-textarea
                type="text"
                label="Alamat Lengkap"
                class="mb-3"
                v-model="agency.address"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <v-select :options="listStatus" v-model="selectedStatus" />
            </div>
          </div>
          <br>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="number"
                icon-after="true"
                icon-pack="feather"
                icon="icon-phone"
                placeholder="No. Telepon"
                class="w-full"
                v-model="agency.phone"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-textarea type="text" label="Deskripsi" class="mb-3" v-model="agency.description" />
            </div>
          </div>
          <!-- <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload()"
              />
            </div>
          </div> -->
          <div class="vx-col mb-3">
            <div class="vx-row w-full">
              <div class="flex flex-row">
                <vs-button
                  class="ml-4"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-send"
                  type="filled"
                  @click="updateData"
                >Simpan</vs-button>
                <vs-button
                  class="ml-4"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-arrow-left"
                  type="border"
                  @click="$router.back()"
                >Kembali</vs-button>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      agency: {
        name: "",
        phone: "",
        address: "",
        description: "",
        logo: "",
        initial: ""
      },
      selectedStatus: {
        value: '',
        label: ''
      },
      listStatus : [
        { value: 1, label: "AKTIF" },
        { value: 0,label: "TIDAK AKTIF"},
      ]
    };
  },
  mounted() {
    this.getData();
  },
  watch:{
    selectedStatus() {
      this.agency.status = this.selectedStatus.value;
    },
  },
  methods: {
    successUpload() {},
    getData() {
      this.$vs.loading();
      this.$http
        .get(`/app/secure/agency/${this.$route.params.id}`)
        .then(r => {
          this.agency = r.data.data.agency;
          this.selectedStatus.value = r.data.data.agency.status;
          this.selectedStatus.label = r.data.data.agency.status == 1 ? 'AKTIF' : 'TIDAK AKTIF';
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    updateData() {
      this.$vs.loading();
      this.$http
        .put(`/app/secure/agency/${this.$route.params.id}`, this.agency)
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menyimpan dinas.",
            color: "success",
            position: "top-right"
          });

          this.$router.push({name : 'agencies-detail', params: {id : this.$route.params.id}})
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  }
};
</script>